import { useGuideContext } from "@knocklabs/react";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics/events";
import { logError } from "@src/appV2/lib/analytics/log";
import { useEffect } from "react";

/**
 * Refetches Knock guides when the browser tab becomes visible again.
 *
 * Web equivalent of the mobile app's `useRefetchKnockGuidesOnResume`. Instead
 * of listening for a Capacitor "resume" event, this watches the Page Visibility
 * API so guides are refreshed when the user returns to the tab.
 */
export function useRefetchKnockGuidesOnVisible() {
  const { client } = useGuideContext();

  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        client.fetch().catch((error: unknown) => {
          logError(APP_V2_APP_EVENTS.KNOCK_GUIDES_REFETCH_ON_VISIBLE_FAILED, { error });
        });
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [client]);
}
